export default {
  id: 'l-7',
  navTitleID: 'l-7.navTitle',
  pages: [
    {
      id: 'page-1',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textID: 'text',
          styling: {
            textAlign: 'center'
          }
        }
      ]
    },
    {
      id: 'page-2',
      components: [
        {
          type: 'video',
          videoSrc: 'KN_09'
        }
      ]
    },
    {
      id: 'page-3',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textLayout: 'inverse',
          textID: 'text'
        }
      ]
    },
    {
      id: 'page-4',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textID: 'text'
        }
      ]
    },
    {
      id: 'page-5',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textID: 'text'
        },
        {
          type: 'carousel',
          slides: [
            {
              type: 'text',
              titleID: 'title1',
              textID: 'text1'
            }, {
              type: 'text',
              titleID: 'title2',
              textID: 'text2'
            },
            {
              type: 'text',
              titleID: 'title3',
              textID: 'text3'
            }
          ]
        }
      ]
    },
    {
      id: 'page-6',
      components: [
        {
          type: 'mc-standard',
          questionID: 'question',
          instructionID: 'instruction',
          hintID: 'hint',
          options: [
            {
              isCorrect: true,
              textID: 'option-1',
              feedbackTextID: 'option-1-feedback'
            },
            {
              isCorrect: false,
              textID: 'option-2',
              feedbackTextID: 'option-2-feedback'
            },
            {
              isCorrect: false,
              textID: 'option-3',
              feedbackTextID: 'option-3-feedback'
            }
          ]
        }
      ]
    },
    {
      id: 'page-7',
      components: [
        {
          type: 'mc-standard',
          questionID: 'question',
          instructionID: 'instruction',
          hintID: 'hint',
          options: [
            {
              isCorrect: true,
              textID: 'option-1',
              feedbackTextID: 'option-1-feedback'
            },
            {
              isCorrect: false,
              textID: 'option-2',
              feedbackTextID: 'option-2-feedback'
            }
          ]
        }
      ]
    },
    {
      id: 'page-8',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textID: 'text'
        },
        {
          type: 'carousel',
          slides: [
            {
              type: 'text',
              titleID: 'title1',
              textID: 'text1'
            }, {
              type: 'text',
              titleID: 'title2',
              textID: 'text2'
            },
            {
              type: 'text',
              titleID: 'title3',
              textID: 'text3'
            }
          ]
        }
      ]
    },
    {
      id: 'page-9',
      components: [
        {
          type: 'text',
          titleID: 'title',
          textID: 'text',
          styling: {
            textAlign: 'center'
          }
        },
        {
          type: 'carousel',
          slides: [
            {
              type: 'text',
              titleID: 'empty',
              textID: 'text1'
            }, {
              type: 'text',
              titleID: 'empty',
              textID: 'text2'
            },
            {
              type: 'text',
              titleID: 'empty',
              textID: 'text3'
            },
            {
              type: 'text',
              titleID: 'empty',
              textID: 'text4'
            },
            {
              type: 'text',
              titleID: 'empty',
              textID: 'text5'
            }
          ]
        }
      ]
    },
    {
      id: 'page-10',
      components: [
        {
          type: 'image',
          src: '/deltakere/stefansmiler.png',
          alt: 'Bilde av Stefan',
          width: '20rem',
          height: 'auto'
        },
        {
          type: 'mc-standard',
          questionID: 'question',
          instructionID: 'instruction',
          hintID: 'hint',
          options: [
            {
              isCorrect: false,
              textID: 'option-1',
              feedbackTextID: 'option-1-feedback'
            },
            {
              isCorrect: true,
              textID: 'option-2',
              feedbackTextID: 'option-2-feedback'
            }
          ]
        }
      ]
    }
  ]
}
